import { render, staticRenderFns } from "./batch-form.vue?vue&type=template&id=584ca47b&"
import script from "./batch-form.vue?vue&type=script&lang=js&"
export * from "./batch-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports